var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "m"
  }, [_c('el-input', {
    staticClass: "mr10 f-search-bar",
    attrs: {
      "placeholder": "成交单号、申报人"
    },
    model: {
      value: _vm.queryData.keywords,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "keywords", $$v);
      },
      expression: "queryData.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  }, [_vm._v("搜索")])], 1), _c('el-select', {
    staticClass: "mr10",
    attrs: {
      "placeholder": "成交项目",
      "clearable": "",
      "filterable": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: _vm.queryData.estateId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "estateId", $$v);
      },
      expression: "queryData.estateId"
    }
  }, _vm._l(_vm.estateList, function (item) {
    return _c('el-option', {
      key: item.estateId,
      attrs: {
        "value": item.estateId,
        "label": item.estateName
      }
    });
  }), 1), _c('el-cascader', {
    staticClass: "mr10",
    attrs: {
      "props": _vm.props,
      "options": _vm.mechanismCascadeList,
      "clearable": "",
      "filterable": "",
      "placeholder": "合作渠道",
      "separator": "-"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: _vm.queryData.mechanismId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "mechanismId", $$v);
      },
      expression: "queryData.mechanismId"
    }
  }), _c('el-select', {
    staticClass: "mr10",
    attrs: {
      "placeholder": "结单状态",
      "clearable": "",
      "collapse-tags": "",
      "multiple": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: _vm.queryData.statusList,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "statusList", $$v);
      },
      expression: "queryData.statusList"
    }
  }, _vm._l(_vm.statusArr.filter(function (s) {
    return !s.hide;
  }), function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    });
  }), 1), _c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "-",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: _vm.queryData.date,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "date", $$v);
      },
      expression: "queryData.date"
    }
  }), _c('el-checkbox', {
    staticClass: "ml10",
    attrs: {
      "label": "已撤单"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: _vm.queryData.showCanceled,
      callback: function callback($$v) {
        _vm.$set(_vm.queryData, "showCanceled", $$v);
      },
      expression: "queryData.showCanceled"
    }
  })], 1), _c('el-button-group', {
    staticClass: "actions-btn"
  }, [_c('f-table-fields', {
    attrs: {
      "name": "transactionManageTab1",
      "options": _vm.defaultFields
    },
    on: {
      "change": _vm.onFieldsChange
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "iconfont icon-list"
    }
  })], 1), _c('el-button', {
    attrs: {
      "icon": "iconfont icon-refresh"
    },
    on: {
      "click": _vm.getList
    }
  })], 1)], 1), _c('f-table', {
    ref: "table",
    staticClass: "mt20",
    attrs: {
      "border": "",
      "data": _vm.list,
      "row-class-name": _vm.tableRowClassName,
      "columns": _vm.tableColumns
    }
  }), _vm.list.length ? _c('div', {
    staticClass: "total-collect"
  }, [_vm._v(" 合计应结金额："), _c('span', [_vm._v("¥" + _vm._s(_vm._f("toThousands")(_vm.sumData.amount)))]), _vm._v(" 　 合计已结金额："), _c('span', [_vm._v("¥" + _vm._s(_vm._f("toThousands")(_vm.sumData.amountEnd)))])]) : _vm._e(), _c('f-pagination', {
    attrs: {
      "page-num": _vm.queryData.pageNum,
      "page-size": _vm.queryData.pageSize,
      "total": _vm.total
    },
    on: {
      "update:pageNum": function updatePageNum($event) {
        return _vm.$set(_vm.queryData, "pageNum", $event);
      },
      "update:page-num": function updatePageNum($event) {
        return _vm.$set(_vm.queryData, "pageNum", $event);
      },
      "update:pageSize": function updatePageSize($event) {
        return _vm.$set(_vm.queryData, "pageSize", $event);
      },
      "update:page-size": function updatePageSize($event) {
        return _vm.$set(_vm.queryData, "pageSize", $event);
      },
      "change": _vm.getList
    }
  }), _c('order-detail', {
    ref: "orderDetail",
    attrs: {
      "visible": _vm.detailDialog,
      "detailId": _vm.detailId
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.detailDialog = $event;
      },
      "cancelOrder": _vm.cancelOrder,
      "editOrder": _vm.showEditDialog,
      "handleReceipt": _vm.handleReceipt,
      "accountOrder": _vm.accountOrder
    }
  }), _c('receipt-dialog', {
    attrs: {
      "visible": _vm.receiptDialog,
      "editId": _vm.editId,
      "detail": _vm.detail
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.receiptDialog = $event;
      },
      "success": _vm.handleSuccess
    }
  }), _c('edit-order-dialog', {
    attrs: {
      "visible": _vm.editDialog,
      "detailId": _vm.detailId
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.editDialog = $event;
      },
      "success": _vm.handleSuccess
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }